"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconDolar = function SvgIconDolar(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "dolar icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Dolar Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M35.271 29.875c0 4.25-2.833 8.25-7.917 9.292v4.832l-5.75.001v-4.833c-3.958-.668-6.791-2.792-8.875-5.292l5.166-4.042c1.542 2.583 4.125 4.042 6.71 4.042 2.833 0 4.665-1.792 4.665-3.875 0-2.583-3.124-3.333-6.375-4.25-4.042-1.167-8.916-2.958-8.916-8.792 0-4.208 3.042-7.583 7.542-8.541V4h5.708v4.417c3.292.625 5.584 2.291 7.374 4.375l-4.75 3.624c-1.25-2-3.25-3.125-5.625-3.125-2.583 0-4.332 1.459-4.332 3.375 0 2.459 2.916 3.042 6.333 4.084 4.125 1.291 9.042 3.208 9.042 9.125z"
  }));
};

var _default = SvgIconDolar;
exports.default = _default;